export default __webpack_public_path__ + "static/media/showcase.51cab55d.jpg";